import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getClassEntries, getStaffEntries } from "../firebase/functions";

const initialState = {
  classes: {
    data: [],
  },
  staff: {
    data: [],
  },
  students: {
    data: [],
  },
};

export const classesThunk = createAsyncThunk("admin/classes", async (args) => {
  try {
    const classEntries = await getClassEntries();

    return classEntries;
  } catch (error) {}
});

export const staffThunk = createAsyncThunk("admin/staff", async (args) => {
  try {
    const staffEntries = await getStaffEntries();

    return staffEntries;
  } catch (error) {}
});

const adminDataSlice = createSlice({
  name: "adminData",
  initialState,
  reducers: {},
  extraReducers: {
    [classesThunk.pending]: () => {},
    [classesThunk.fulfilled]: (state, action) => {
      state.classes.data = action.payload;
    },
    [staffThunk.pending]: () => {},
    [staffThunk.fulfilled]: (state, action) => {
      state.staff.data = action.payload;
    },
  },
});

const adminDataReducer = adminDataSlice.reducer;

export default adminDataReducer;
